import { PropsWithChildren } from "react";
import { useElementSize } from "react-migration/lib/util/useElementSize";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

type TruncatedProps = PropsWithChildren<{
  onSeeMoreInfo: () => void;
  isExpanded: boolean;
  seeMoreText?: string;
}>;

export function Truncated({ children, onSeeMoreInfo, isExpanded, seeMoreText }: TruncatedProps) {
  const { t } = useTranslation();
  const maxHeight = 296;
  const [contentRef, { height: contentHeight }] = useElementSize();
  const showSeeMore = Math.ceil(contentHeight) >= maxHeight;

  return (
    <>
      {isExpanded ? (
        <div className="h-full overflow-auto">{children}</div>
      ) : (
        <div ref={contentRef} style={{ maxHeight }} className="relative bg-white overflow-hidden">
          {children}
          {showSeeMore && (
            <a
              onClick={onSeeMoreInfo}
              style={{ background: "linear-gradient(0deg, white 65%, rgba(255, 255, 255, 0))" }}
              className="block p-3 pt-6 text-sm font-semibold text-text-base-active hover:text-text-base-active-hover cursor-pointer absolute bottom-0 right-0 left-0"
            >
              {seeMoreText || t("domains.bundle.components.see_more_info")}
            </a>
          )}
        </div>
      )}
    </>
  );
}
